import requestInstance from "./Request";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;

const greetingService = {
  // GET: Fetch all greetings
  async getGreetingList(params = {}) {
    try {
      const response = await requestInstance.get(`${BASE_URL}/admin-api/v3/greeting`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching greeting list:", error);
      throw error;
    }
  },

  // GET: Fetch greeting by ID
  async getGreetingById(greetingId) {
    try {
      const response = await requestInstance.get(`${BASE_URL}/admin-api/v3/greeting/${greetingId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching greeting by ID:", error);
      throw error;
    }
  },

  // POST: Create a new greeting
  async createGreeting(greetingData) {
    try {
      const response = await requestInstance.post(
        `${BASE_URL}/admin-api/v3/greeting`,
        greetingData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating greeting:", error);
      throw error;
    }
  },

  // PATCH: Update a greeting
  async updateGreeting(greetingId, updatedData) {
    try {
      const response = await requestInstance.patch(
        `${BASE_URL}/admin-api/v3/greeting/${greetingId}`,
        updatedData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating greeting:", error);
      throw error;
    }
  },

  // DELETE: Delete a greeting
  async deleteGreeting(greetingId) {
    try {
      const response = await requestInstance.delete(`${BASE_URL}/admin-api/v3/greeting/${greetingId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting greeting:", error);
      throw error;
    }
  },
};

export default greetingService;